import React from 'react';
import { API } from 'aws-amplify';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import { t } from 'i18next';

const useRenewals = (AppDefID, handleClose) => {
    const [renewals, setRenewals] = React.useState([]);
    const [term, setTerm] = React.useState('');
    const [doingAjax, setDoingAjax] = React.useState(true);
    const [initialized, setInitialized] = React.useState(false);
    const history = useHistory();

    const retrieveRenewals = async () => {
        try {
            setInitialized(false);
            setDoingAjax(true);

            let [_appTerm, _renewals] = await Promise.all([
                API.get('ShipyardAPI', '/applications/application_term'),
                API.get('ShipyardAPI', '/parent/renewals'),
            ]);

            setTerm(_appTerm.currentTerm);
            setRenewals(_renewals.renewalStudents);

            setDoingAjax(false);
            setInitialized(true);
        } catch (e) {
            toast.error(t('General.AjaxError'));
            handleClose?.();
        }
    };

    const startApplication = async (studentId) => {
        setDoingAjax(true);
        try {
            let body = {
                applicationId: AppDefID,
            };

            if (studentId !== -1) body.studentId = studentId;

            let startNewResponse = await API.post('ShipyardAPI', '/application', {
                body,
            });

            if (!startNewResponse.applicationInstanceId) {
                toast.error(t('General.AjaxError'));
                setDoingAjax(false);
            }

            history.push('/application/' + startNewResponse.applicationInstanceId);
            handleClose?.();
        } catch (e) {
            toast.error(t('General.AjaxError'));
            setDoingAjax(false);
        }
    };

    return {
        renewals,
        term,
        doingAjax,
        initialized,
        retrieveRenewals,
        startApplication,
    };
};

export default useRenewals;
